import React from 'react';

interface StateContextValue
  extends Readonly<{
    shouldAutoscrollJourneyAtFirst: boolean;
    shouldShowJourneyInfoDialogAtFirst: boolean;
    setShouldAutoscrollJourneyAtFirst: (value: boolean) => void;
    setShouldShowJourneyInfoDialogAtFirst: (value: boolean) => void;
  }> {}

const Context = React.createContext<StateContextValue>({
  shouldAutoscrollJourneyAtFirst: true,
  shouldShowJourneyInfoDialogAtFirst: true,
  setShouldAutoscrollJourneyAtFirst: () => {
    throw new Error('StateContextProvider not found!');
  },
  setShouldShowJourneyInfoDialogAtFirst: () => {
    throw new Error('StateContextProvider not found!');
  },
});

interface StateContextProviderProps
  extends Readonly<{
    shouldAutoscrollJourneyAtFirst: boolean;
    shouldShowJourneyInfoDialogAtFirst: boolean;
    children?: React.ReactNode;
  }> {}

export const StateContextProvider = React.memo<StateContextProviderProps>((props) => {
  const [shouldAutoscrollJourneyAtFirst, setShouldAutoscrollJourneyAtFirst] = React.useState<boolean>(
    () => props.shouldAutoscrollJourneyAtFirst
  );

  const [shouldShowJourneyInfoDialogAtFirst, setShouldShowJourneyInfoDialogAtFirst] = React.useState<boolean>(
    () => props.shouldShowJourneyInfoDialogAtFirst
  );

  const ContextValue = React.useMemo(() => {
    const contextValue: StateContextValue = {
      shouldAutoscrollJourneyAtFirst,
      shouldShowJourneyInfoDialogAtFirst,
      setShouldAutoscrollJourneyAtFirst,
      setShouldShowJourneyInfoDialogAtFirst,
    };

    return contextValue;
  }, [shouldAutoscrollJourneyAtFirst, shouldShowJourneyInfoDialogAtFirst]);

  return <Context.Provider value={ContextValue}>{props.children}</Context.Provider>;
});

export const useStateContext = () => React.useContext<StateContextValue>(Context);
